/* NORD slideshow — JS estático extraído do <script> inline da seção.
   Sem nenhuma interpolação Liquid, então as 3 instâncias da home enviavam
   17,1KB do MESMO script no HTML. Como asset, baixa uma vez e fica em cache. */
if (!customElements.get('nord-slideshow')) {
    customElements.define('nord-slideshow', class NordSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.nord-slideshow__slide'));
        if (this.slides.length < 2) return;

        this.index = 0;
        this.timer = null;
        this.animating = false;
        this.userPaused = false;
        this.inView = true;
        this.speed = (parseFloat(this.dataset.speed) || 6) * 1000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (this.reducedMotion.matches) this.dataset.transition = 'fade';
        this.autoplayEnabled = this.dataset.autoplay === 'true' && !this.reducedMotion.matches;

        this.track = this.querySelector('.nord-slideshow__track');
        this.liveRegion = this.querySelector('[data-live-region]');
        this.dots = Array.from(this.querySelectorAll('.nord-slideshow__dot'));
        this.pauseBtn = this.querySelector('.nord-slideshow__pause');

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const i = parseInt(dot.dataset.dotIndex, 10);
            this.goTo(i, i > this.index ? 1 : -1, true);
          });
        });

        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.pauseBtn.setAttribute('aria-pressed', String(this.userPaused));
            this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
            if (this.userPaused) this.stop(); else this.start();
          });
        }

        this.setAttribute('tabindex', '0');
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.next(true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(true); }
        });

        if (this.dataset.pauseOnHover === 'true') {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => { if (!this.userPaused) this.start(); });
        }
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget) && !this.userPaused) this.start();
        });

        // Basic swipe support
        this.addEventListener('touchstart', (e) => { this.touchX = e.changedTouches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (this.touchX == null) return;
          const dx = e.changedTouches[0].clientX - this.touchX;
          this.touchX = null;
          if (Math.abs(dx) > 50) { dx < 0 ? this.next(true) : this.prev(true); }
        }, { passive: true });

        // Pause when offscreen
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => {
            this.inView = entries[0].isIntersecting;
            if (!this.inView) this.stop();
            else if (!this.userPaused) this.start();
          }, { threshold: 0.1 }).observe(this);
        }

        // Theme editor: jump to selected slide
        if (window.Shopify && window.Shopify.designMode) {
          this.addEventListener('shopify:block:select', (e) => {
            const slide = e.target.closest('[data-slide-index]');
            if (!slide) return;
            this.userPaused = true;
            this.stop();
            this.goTo(parseInt(slide.dataset.slideIndex, 10), 1, false);
          });
        }

        this.syncA11y();
        if (this.autoplayEnabled) this.start();
      }

      disconnectedCallback() { this.stop(); }

      start() {
        if (!this.autoplayEnabled || this.timer || !this.inView) return;
        this.timer = setInterval(() => this.next(false), this.speed);
        this.track.setAttribute('aria-live', 'off');
      }

      stop() {
        if (this.timer) { clearInterval(this.timer); this.timer = null; }
        this.track.setAttribute('aria-live', 'polite');
      }

      next(user) { this.goTo((this.index + 1) % this.slides.length, 1, user); }
      prev(user) { this.goTo((this.index - 1 + this.slides.length) % this.slides.length, -1, user); }

      goTo(newIndex, direction, user) {
        if (newIndex === this.index || this.animating) return;
        if (user) { this.stop(); if (!this.userPaused) this.start(); }

        const current = this.slides[this.index];
        const target = this.slides[newIndex];
        const enterClass = direction > 0 ? 'is-entering-next' : 'is-entering-prev';

        this.animating = true;
        current.classList.add('is-prev');
        current.classList.remove('is-active');
        target.classList.add('is-active', enterClass);
        target.getBoundingClientRect(); // force reflow so the transition runs
        target.classList.remove(enterClass);

        window.setTimeout(() => {
          current.classList.remove('is-prev');
          this.animating = false;
        }, this.reducedMotion.matches ? 50 : 850);

        this.index = newIndex;
        this.syncA11y();
        if (this.liveRegion) this.liveRegion.textContent = 'Slide ' + (newIndex + 1) + ' of ' + this.slides.length;
      }

      syncA11y() {
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.setAttribute('aria-hidden', String(!active));
          slide.querySelectorAll('a, button').forEach((el) => {
            if (active) el.removeAttribute('tabindex');
            else el.setAttribute('tabindex', '-1');
          });
        });
        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    });
  }
